/**
 * @efacture/fiscal-core - Payment methods
 *
 * The one list of the methods a settlement is recorded with, and the subset
 * each entry point accepts. `InvoicePayment.method` and `POSPayment.method`
 * store these codes; the X and Z reports group by them and print their
 * labels, the declared payments (#1093) accept exactly them, and the annex
 * maps them to its 35h codes (`SECEF_PAYMENT_METHOD_CODES`,
 * secef/session-plan.ts).
 *
 * @module models/payment
 */
/**
 * Payment methods recorded on invoices and till receipts, in report order.
 */
export const PAYMENT_METHODS = {
    /** Cash */
    ESPECES: {
        code: "ESPECES",
        label: "Espèces",
    },
    /** Cheque */
    CHEQUE: {
        code: "CHEQUE",
        label: "Chèque",
    },
    /** Bank transfer */
    VIREMENT: {
        code: "VIREMENT",
        label: "Virement bancaire",
    },
    /** Bank card */
    CARTE_BANCAIRE: {
        code: "CARTE_BANCAIRE",
        label: "Carte bancaire",
    },
    /** Mobile money (Orange Money, Moov Money, etc.) */
    MOBILE_MONEY: {
        code: "MOBILE_MONEY",
        label: "Mobile Money",
    },
    /** Credit sale */
    CREDIT: {
        code: "CREDIT",
        label: "Crédit",
    },
    /** Settlement by offsetting a credit note */
    AVOIR: {
        code: "AVOIR",
        label: "Avoir",
    },
    /** Settlement with loyalty points */
    POINTS: {
        code: "POINTS",
        label: "Points de fidélité",
    },
    /** Any other method */
    AUTRE: {
        code: "AUTRE",
        label: "Autre",
    },
};
/**
 * Methods a till payment is added with (POST /api/pos/transactions/:id/payments):
 * every method but AUTRE, in the order the till shows them.
 */
export const TILL_PAYMENT_METHOD_CODES = [
    "ESPECES",
    "CARTE_BANCAIRE",
    "MOBILE_MONEY",
    "CHEQUE",
    "VIREMENT",
    "CREDIT",
    "AVOIR",
    "POINTS",
];
/**
 * Methods an invoice settlement is recorded with, at issue (POST and PUT
 * /api/invoices, the debit note) and afterwards (POST
 * /api/invoices/:id/payments): every method but POINTS and AUTRE.
 */
export const INVOICE_PAYMENT_METHOD_CODES = [
    "ESPECES",
    "CHEQUE",
    "VIREMENT",
    "CARTE_BANCAIRE",
    "MOBILE_MONEY",
    "CREDIT",
    "AVOIR",
];
/** The method every company accepts, whatever its payment-method setting. */
export const CASH_PAYMENT_METHOD = "ESPECES";
/** The Mobile Money operators a till payment names, as `POSPayment.provider` stores them. */
export const MOBILE_MONEY_OPERATORS = ["Orange Money", "Moov Money", "Coris Money"];
//# sourceMappingURL=payment.js.map